export default __webpack_public_path__ + "static/media/ipad-big.78d58814.png";